module.exports = __webpack_public_path__ + "media/header-global.4b535fd6.mp4";